<template>

    <div :class=" PaginatorClasses ">

        <div class="pager-wrapper" @click=" changePage( -1 ) ">

            <font-awesome-icon v-if=" totalPages > 1 && currentPage > 1" icon="caret-left" style="font-size: 25px;"/>
        </div>
        <div class="page-number">

            {{ currentPage }}
        </div>
        <div class="pager-wrapper" @click=" changePage( 1 ) ">

            <font-awesome-icon v-if=" totalPages > 1 && currentPage < totalPages" icon="caret-right" style="font-size: 25px;"/>
        </div>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import { mapGetters } from 'vuex';

    export default {

        name: 'paginator',
        props: {

            totalPages  : Number,
            currentPage : Number,
            changePage  : Function
        },
        computed: {

            ...mapGetters({

                tabOpen : 'orderTab/tabOpen'
            }),
            PaginatorClasses(){

                const base = [ 'outer-wrapper' ];
                base.push( ( this.tabOpen ) ? 'tab-open' : 'tab-closed' );
                return base.join( ' ' );
            }
        },
        components: {

            FontAwesomeIcon
        },
    }
</script>

<style scoped>

    .outer-wrapper {

        display: flex;
        align-items: center;
        justify-content: center;

        position: fixed;
        width: 100%;

        transition: bottom 0.3s ease-in;
    }
    .tab-open {

        bottom: 135px;
    }
    .tab-closed {

        bottom: 80px;
    }
    .page-number {

        display: flex;
        align-items: center;
        justify-content: center;

        border: 2px solid black;
        background-color: rgb(58, 171, 38);
        width: 45px;
        height: 45px;
        text-align: center;
        color: white;
        font-size: 20px;
        font-weight: bold;

        margin: 0px 15px;
    }
    .pager-wrapper {

        width: 20px;
        text-align: center;
    }
</style>
